import { z } from 'zod';

export const getCategoriesQuerySchema = z.object({
  search: z.string().optional(),
  type: z.string().optional(),
});

export const CategoryType = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  level: z.number(),
  tagsCount: z.number(),
});

export const OldCategoryType = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  level: z.number(),
  tagsCount: z.number(),
});

export const getCategoriesResponseSchema = z.record(
  z.string(),
  z.object({
    name: z.string(),
    categories: z.array(CategoryType),
  }),
);

export type CategoriesBffResponse = z.infer<typeof getCategoriesResponseSchema>;

export type CategoryBffType = z.infer<typeof CategoryType>;

export const getOldCategoriesResponseSchema = z.array(OldCategoryType);
